import axios from 'axios';
import { IFreshServiceTicketFormValues } from '../../../@types/model/freshService/freshServiceTicketFormValues';

export default class FreshServiceHttpService {
    public static upsert = async (ticketValues : IFreshServiceTicketFormValues) : Promise<void> => {
        return await axios.post(`${API_URL}/v1/FreshService/CreateTicket`, ticketValues);
    };
}
